import { http } from "@/http";

export const deleteStudy = async(id:string) => {
	await http.delete(`studies/${id}`);
};